/**
 * The app shell — a direct transcription of the Next.js `app/layout.tsx` body.
 *
 * Provider ORDER is load-bearing and must not be rearranged:
 *   Authentication -> SuiDappKit -> Referrals -> SuiQuery -> LicenseLeases -> Claims
 * Claims calls `useLicenseLeasesContext`, LicenseLeases and Referrals read the
 * connected account from dapp-kit, and everything value-moving needs
 * `generateNonce` from Authentication. Each provider therefore has to sit inside
 * the ones it consumes.
 *
 * `Providers` (NextUI + theme) is inside the router because it needs
 * `useNavigate`; the router itself is mounted in `main.tsx`.
 */
import { Outlet } from "react-router-dom";

import { Navbar } from "@/components/navbar";
import { AuthenticationContextController } from "@/context/authentication/AuthenticationContextController";
import { ClaimsContextController } from "@/context/claims/ClaimsContextController";
import { LicenseLeasesContextController } from "@/context/license-leases/LicenseLeasesContextController";
import { ReferralsContextController } from "@/context/referrals/ReferralsContextController";
import { SuiDappKitContextController } from "@/context/SUIDappKit/SuiDappKitContextController";
import { SuiQueryContextController } from "@/context/SUIQuery/SuiQueryContextController";
import { Toaster } from "@/ui/shadcn/toaster";

import { Providers } from "./providers";

export function RootLayout() {
  return (
    <Providers themeProps={{ attribute: "class", defaultTheme: "dark" }}>
      <AuthenticationContextController>
        <SuiDappKitContextController>
          <ReferralsContextController>
            <SuiQueryContextController>
              <LicenseLeasesContextController>
                <ClaimsContextController>
                  <div className="relative flex" id="app-shell">
                    <Navbar />

                    <main className="relative min-h-screen w-full" id="app-main">
                      <Outlet />
                    </main>

                    <Toaster />
                  </div>
                </ClaimsContextController>
              </LicenseLeasesContextController>
            </SuiQueryContextController>
          </ReferralsContextController>
        </SuiDappKitContextController>
      </AuthenticationContextController>
    </Providers>
  );
}
